<template>
  <div class="my-quotation-wrap">
    <div class="table-header-tab-wrap">
      <div class="tab" :class="{'active': curTabIndex === 1}" @click="filter(1)">销售中</div>
      <div class="tab" :class="{'active': curTabIndex === 3}" @click="filter(3)">未发布</div>
      <div class="tab" :class="{'active': curTabIndex === 0}" @click="filter(0)">全部</div>
      <div class="right-wrap">
        <el-input placeholder="请输入编号或品牌" @keyup.enter.native="retrieve(1)" v-model="query.searchStr" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="retrieve(1)"></el-button>
        </el-input>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" stripe v-loading="loading">
        <el-table-column label="报价编号" prop="contangoCode" width="140" />
        <el-table-column label="品牌" prop="brandName" width="90" />
        <el-table-column label="升贴水单价" prop="liftingWater" width="90" />
        <el-table-column label="等级" prop="grade" width="50" />
        <el-table-column label="榨季" prop="season" width="60" />
        <el-table-column label="交货方式" prop="deliveryType" width="100">
          <template slot-scope="scope">
            {{scope.row.deliveryType | keyFilter("releaseQuotation", "deliveryType").name}}
          </template>
        </el-table-column>
        <el-table-column label="交货地" prop="addressStr" />
        <el-table-column label="仓库名" prop="wareHouseAddress" />
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="总发布数量" prop="totalQuantity" width="100" />
        <el-table-column label="剩余数量(吨)" prop="saleableQuantity" width="100" />
        <el-table-column label="已摘牌数量" prop="minQuantity" width="120">
          <template slot-scope="scope">
            {{scope.row.totalQuantity - scope.row.saleableQuantity}}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="contangoStatus">
          <template slot-scope="scope">
            {{scope.row.contangoStatus | keyFilter("myQuotation", "status").name}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <div class="operate-button" @click="toDetail(scope.row, 'detail')">详情</div>
            <div class="operate-button" @click="operate(scope.row, 0)" v-if="scope.row.contangoStatus === '30' && !scope.row.goodsId">下架</div>
            <div class="operate-button" @click="toRelease(scope.row)" v-if="scope.row.contangoStatus === '40'">重新发布</div>
            <div class="operate-button" @click="toDetail(scope.row, 'edit')" v-if="scope.row.contangoStatus === '10'">发布</div>
            <div class="operate-button red-button" @click="del(scope.row)" v-if="scope.row.contangoStatus === '10'">删除</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <pagination @retrieve="retrieve" :isInit="false" :data="pageData" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('framework')

export default {
  name: 'MyQuotation',
  data () {
    return {
      curTabIndex: 1, // 当前焦点tab的索引
      tabStatusList: ['', '30', '20', '10'], // 状态数组
      pageData: {}, // 表格分页数据
      test: '',
      query: { // 搜索内容
        contangoStatus: '30',
        searchStr: ''
      },
      tableData: [],
      loading: false, // 加载层
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
      updateDataFlag: 'updateDataFlag'
    }),
  },
  watch: {
    userInfo: { // 登录信息改变的时候刷新数据
      handler () {
        this.retrieve(1)
      },
      deep: true
    },
    updateDataFlag () { // 数据更新的时候刷新表格
      this.retrieve()
    },
    '$route.query.status' () {
      this.initTab()
    }
  },
  mounted () {
    this.initTab()
  },
  methods: {
    // 获取表格数据
    retrieve (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.loading = true
      this.currentNo = currentNo || this.currentNo || 1
      const url = this.$API.MyQuotation.retrieve
      const param = this.$utils.objectAssign({}, this.query, {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        sortType: this.sortType
      })
      this.$http.post(url, param).then(res => {
        this.tableData = res.data.rows
        this.pageData = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 初始化tab查询
    initTab () {
      // 路由如果带初始状态，就用带的状态进行初始查询
      this.curTabIndex = this.$route.query.status ? Number(this.$route.query.status) : 1
      this.filter(this.curTabIndex)
    },
    // 切换tab
    filter (index) {
      this.curTabIndex = index
      this.query.contangoStatus = this.tabStatusList[index] // 报价状态
      this.retrieve(1)
    },
    // 详情和编辑，row是点击的行数据，type是类型，分detail和edit
    toDetail (row, type) {
      if (type === 'detail') {
        // 神策数据收集
        this.$sensors.track('PublishingPrice', { operation: '发布报价', details: '详情' })
        this.$router.push({ path: `/framework/myTrading/myQuotation/${type}/${row.id}` })
      } else {
        this.$router.push({ path: `/framework/myTrading/myQuotation/${row.id}` })
      }
    },
    // 重新发布
    toRelease (row) {
      this.$router.push({ path: `/framework/releaseQuotation/${row.id}` })
    },
    // 删除报价
    del (row) {
      this.$confirm('您确认删除此报价吗？', '提示', {
        type: 'warning'
      }).then(() => {
        const url = this.$API.MyQuotation.deleteContango
        const param = {
          id: row.id
        }
        this.$http.post(url, param).then(() => {
          this.retrieve()
          // 神策数据收集
          this.$sensors.track('PublishingPrice', { operation: '发布报价', delete: '删除' })
          this.$message.success('操作成功')
        })
      }).catch()
    },
    // 操作函数，row是操作行数据，type=0代表下架，1是发布
    // todo: 发布改为跳转编辑页，此处发布操作暂时保留
    operate (row, type) {
      const url = type === 1 ? this.$API.MyQuotation.releaseMyContango : this.$API.MyQuotation.cancelMyContango
      const tip = type === 1 ? '确定发布该报价吗？' : '确定下架该报价吗？'
      const param = {
        id: row.id
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post(url, param).then(() => {
            this.$message.success('操作成功')
            this.retrieve(this.currentNo)
          })
        })
        .catch(() => {})
    },
  }
}
</script>

<style lang="scss" scoped>
  .my-quotation-wrap{
    .right-wrap{
      /deep/ .el-input__inner{
        width: 200px;
      }
      /deep/ .el-button{
        min-width: 45px !important;
        height: 38px;
        background: #ff6b01;
        border-radius: 0;
        padding: 0 12px !important;
        i{
          color: white;
          font-size: 20px;
        }
      }
    }
  }
</style>
